<template>
  <div class="ws-info-files">
    <div
      v-if="upload"
      class="file-list"
      :class="{outline:outline}"
    >
      <div
        v-for="(attache_e,atteche_k) in attaches"
        :key="atteche_k"
        class="file"
        :class="{twoItem:twoItem,threeItem:threeItem}"
      >
        <WsInfoFileItem
          :text-label="attache_e.url ? attache_e.url : attache_e"
          :num="atteche_k"
          :upload="upload"
          :narrow="narrow"
          :small="small"
          :isloading="attache_e.isloading"
          @deleteFile="$_deleteFile(atteche_k)"
          @no-scroll="$_noScrollClick()"
          @scroll-click="$_scrollClick()"
        />
      </div>
    </div>
    <div
      v-else
      class="file-list"
    >
      <div
        v-for="(attache_e,atteche_k) in attaches"
        :key="atteche_k"
        class="file"
        :class="{twoItem:twoItem,threeItem:threeItem}"
      >
        <WsInfoFileItem
          :text-label="attache_e.url ? attache_e.url : attache_e"
          :narrow="narrow"
          :num="atteche_k"
          :small="small"
          download
          @no-scroll="$_noScrollClick()"
          @scroll-click="$_scrollClick()"
        />
      </div>
    </div>
    <div
      v-if="attaches.length<1 && noFileText"
      class="no-file-list"
    >
      {{ noFileText }}
    </div>
  </div>
</template>
<script>
export default {
  name: "WsInfoFiles",
  props: {
    nonBorderTop: {
      type: Boolean,
      default: false,
    },
    noFileText: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    bigTitle: {
      type: Boolean,
      default: false,
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    threeItem: {
      type: Boolean,
      default: false,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    $_deleteFile(index) {
      this.$emit("delete-file", index);
    },
    $_noScrollClick() {
      this.$emit("no-scroll");
    },
    $_scrollClick() {
      this.$emit("scroll-click");
    },
  },
};
</script>